<form [formGroup]="form" class="text-editor">
    <div class="editor">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [colorPresets]="colorPresets">
        </ngx-editor-menu>
        <ngx-editor [editor]="editor" formControlName="editorContent" [disabled]="disabled">
        </ngx-editor>
    </div>
    <div class="limitestion-text-editore">{{currentLength}} of {{maxLength}} max characters.</div>
</form>